module.exports = __webpack_public_path__ + "wxMicroService/img/abanner@2x.d13a977f.jpg";